// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MsBR","colMin":"styles_colMin__2b4vB"};